import Router from './Router'

import HeaderController from './controllers/HeaderController'
//import PopinController from './controllers/PopinController'
import HomeController from './controllers/HomeController'
import PlanningController from './controllers/PlanningController'
import InfosController from './controllers/InfosController'
import SportController from './controllers/SportController';
import CoachController from './controllers/CoachController';
import RestaurantController from './controllers/RestaurantController';
import EventController from './controllers/EventController';
import SingleEventController from './controllers/SingleEventController';
import SingleClubController from './controllers/SingleClubController';
import AvantageController from './controllers/AvantageController';
import AccountController from './controllers/AccountController';
import AsyncLoader from './modules/AsyncLoader';
import SingleOffersController from './controllers/SingleOffersController';

const controllers = {
  header: new HeaderController(),
 // popin: new PopinController(), 
  home: new  HomeController(),
  planning: new PlanningController(),
  infos: new InfosController(),
  sport: new SportController(),
  coach: new CoachController(),
  restaurant: new RestaurantController(),
  event: new EventController(),
  singleEvent: new SingleEventController(),
  singleClub: new SingleClubController(),
  avantage: new AvantageController(),
  account: new AccountController(), 
  singleOffers: new SingleOffersController(),
}

document.addEventListener('DOMContentLoaded', () => {
  new Router(controllers)
  // new AsyncLoader()
})